import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import {
  DefaultListResponse,
  DefaultPageState,
} from "../../../common/models/StoreDefaultModel";

const InitialRequest = {
  page: 1,
  itemsPerPage: 10,
};

export type ActionedTransportOrder = {
  data: any;
  action: ActionsKey;
};

type TransportOrderDataType = {
  list: any;
  detail: any | null;
  actioned: ActionedTransportOrder | null;
  totalItems?: number;
  setDetail: (detail: any | null) => void;
  setList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedTransportOrder | null) => void;
  pageState: DefaultPageState;
  setPageState: (state: DefaultPageState) => void;
  resetPageState: () => void;
};

export const useTransportOrderStore = create<TransportOrderDataType>((set) => ({
  list: [],
  detail: null,
  actioned: null,
  totalItems: 0,
  pageState: InitialRequest,
  setDetail: (detail) => set((state) => ({ detail })),
  setList: (levageData) =>
    set((state) => ({
      list: levageData?.member,
      totalItems: levageData?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
  setPageState: (pageState) => set((state) => ({ pageState })),
  resetPageState: () =>
    set(() => ({
      pageState: InitialRequest,
    })),
}));
